import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { getBodyMeasure } from '../../pages/appointment/modules/bodyMeasures';
import {
  SKINFOLD_PROTOCOLS,
  ageAt,
  computeBodyComposition,
  protocolFolds,
} from '../../pages/appointment/components/bodyMeasurements/bodyComposition';
import { describeCompositionGap, formatNumber, parseInput } from '../../pages/appointment/components/bodyMeasurements/bodyMeasurementsMath';
import styles from './CreateBodyMeasurementsPopup.module.css';

/**
 * Dobras cutâneas do formulário: o protocolo escolhido decide quais dobras
 * aparecem (as do sexo do paciente) e, abaixo, o resultado ao vivo
 * (densidade, % de gordura, massa gorda e magra) ou o que falta para calcular.
 *
 * `values`: textos digitados do formulário; `renderRow`: linha padrão do popup.
 */
const SkinfoldSection = ({ protocol, onProtocolChange, values, variant, birthday, date, renderRow }) => {
  const folds = protocolFolds(protocol, variant);

  let summary = null;
  if (protocol) {
    const typedFolds = {};
    folds.forEach((key) => { typedFolds[key] = parseInput(values[key]); });
    const result = computeBodyComposition({
      protocol,
      sex: variant,
      age: ageAt(birthday, date),
      weight: parseInput(values.weight),
      folds: typedFolds,
    });
    summary = result.ok
      ? [
        `Gordura ${formatNumber(result.bodyFat, 1)}%`,
        `densidade ${formatNumber(result.density, 4)} g/mL`,
        result.fatMass === null ? 'informe o peso para as massas' : `massa gorda ${formatNumber(result.fatMass, 1)} kg`,
        result.leanMass === null ? null : `massa magra ${formatNumber(result.leanMass, 1)} kg`,
      ].filter(Boolean).join(' · ')
      : describeCompositionGap(result);
  }

  return (
    <div className={styles.section}>
      <span className={styles.sectionTitle}>Dobras cutâneas</span>
      <div className={styles.rows}>
        <div className={styles.row}>
          <span className={styles.rowLabel}>Protocolo</span>
          <FormControl size="small" className={styles.sourceField}>
            <Select
              displayEmpty
              value={protocol}
              onChange={(e) => onProtocolChange(e.target.value)}
              renderValue={(value) => {
                const selected = SKINFOLD_PROTOCOLS.find((item) => item.key === value);
                return selected ? selected.label : <span className={styles.placeholder}>Sem dobras</span>;
              }}
            >
              <MenuItem value="">Sem dobras</MenuItem>
              {SKINFOLD_PROTOCOLS.map((item) => (
                <MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {folds.map((key) => renderRow(getBodyMeasure(key)))}
      </div>
      {summary && <span className={styles.compositionSummary}>{summary}</span>}
    </div>
  );
};

export default SkinfoldSection;
